<template>
  <b-modal :id="modalId" size="lg" centered @hidden="hide" modal-class="modal-digital-items"
           :footer-class="'justify-content-center'">

    <overlay :show="displayDownload"></overlay>

    <template v-slot:modal-header>
      <div class="fraction">&nbsp;</div>
      <button type="button" aria-label="Close" class="close" @click="hide"></button>
    </template>
    <div class="video-item">
      <vue-plyr v-if="video">
        <video :poster="video.image_url" :src="video.media_original_url || video.media_preview_url" autoplay>
          <source :src="video.media_original_url || video.media_preview_url" :type="mimeType" size="720">
        </video>
      </vue-plyr>
    </div>


    <template v-slot:modal-footer v-if="video">
      <!-- MOBILE DOWNLOAD BUTTONS -->
      <div class="d-flex justify-content-center download-container-mobile d-block d-md-none"
           :class="{'on': displayDownload}">
        <ul class="nav nav-pills align-items-center flex-column w-100">
          <li class="nav-item mb-4"><h4>{{ $t('collage_photo_item.download_video') }}</h4></li>
          <li class="nav-item mb-3" v-if="mediaUrlHD">
            <ButtonDownloadPhoto :media-url="mediaUrlHD"
                                 :has-pica-service-photo-original="true"
                                 :size="SIZE_HD_VIDEO"
                                 :id="video.id"
                                 :dt-photos-hd-available-formatted="dtPhotosHdAvailableFormatted"
                                 :label="$t('collage_photo_item.sd_size_only')"
                                 @click="trackShare('download');displayDownload=false"/>
          </li>
          <li class="nav-item">
            <b-button variant="light" @click="displayDownload=false">{{ $t('photo_chooser.action_close') }}</b-button>
          </li>
        </ul>
      </div>
      <div class="d-flex align-items-center action-container" v-if="video.is_shareable">
        <div class="wrap-sharing" :class="{'on': displaySharing}">
          <ul class="nav nav-pills social-sharing">
            <li class="nav-item">
              <a href="#" class="nav-link" @click.prevent="displaySharing=false">
                <icon-back/>
              </a>
            </li>
            <li class="nav-item" v-for="(network, index) in socialNetworksList" :key="index">
                  <Sharer :event-name="eventName"
                        :url-to-share="video.media_original_url"
                        :network="network"
                        @click="trackShare(network)">
                </Sharer>
            </li>
          </ul>
        </div>
        <div class="wrap-sharing d-none d-md-block w-100" :class="{'on': displayDownload}">
           <div class="row align-items-center justify-content-center">
            <div class="col-md-6 col-lg-4" v-if="mediaUrlHD">

              <ButtonDownloadPhoto :media-url="mediaUrlHD"
                                   :has-pica-service-photo-original="true"
                                   :size="SIZE_HD_VIDEO"
                                   :dt-photos-hd-available-formatted="dtPhotosHdAvailableFormatted"
                                   :label="$t('collage_photo_item.sd_size_only')"
                                   @click="trackShare('download');displayDownload=false"/>
            </div>
            <div class="col-md-auto">
              <a href="#" @click.prevent="displayDownload=false">
                <icon-back/>
              </a>
            </div>
           </div>
        </div>
        <div class="wrap-actions" :class="{'off': displaySharing || displayDownload}">
          <ul class="nav nav-pills photo-actions">
            <li class="nav-item">
              <a href="#" class="nav-link icon-share" @click.prevent="displayDownload=true">
                <icon-download></icon-download>
              </a>
            </li>
            <li class="nav-item" v-if="isSharingEnabled">
              <a href="#" class="nav-link icon-share" @click.p.prevent="displaySharing=true">
                <icon-share></icon-share>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </template>


  </b-modal>
</template>

<script>
import EventService from '@/services/Event.js'
import ButtonDownloadPhoto from '@/components/ButtonDownloadPhoto'
import IconShare from "@/components/interface/svg/IconShare.vue";
import IconBack from "@/components/interface/svg/IconBack.vue";
import IconDownload from "@/components/interface/svg/IconDownload.vue";
import {SIZE_HD_VIDEO} from "@/components/ButtonDownloadPhoto.vue";
import Overlay from "@/components/interface/fragments/Overlay.vue";
import metric_message from "@/domain/metrics/message";
import Gallery from "@/domain/metrics/gallery";
import Sharer from "@/components/Sharer.vue";
import {socialNetworksList} from "@/domain/checkinDetail/constants";

export default {
  components: {
    Sharer,
    IconDownload,
    IconBack,
    IconShare,
    ButtonDownloadPhoto,
    Overlay
  },

  props: {
    video: {Object, required: false},
    mimeType: {type: String, default: 'video/mp4'},
    eventName: {type: String},
    eventDate: {type: String},
    shareMode: {type: String, default: 'null'},
    dtPhotosHdAvailableFormatted: {type: String}
  },

  data() {
    return {
      currentPhotoShareDescription: '',
      displaySharing: false,
      displayDownload: false,
      showDownloadOverlayForMobile: false
    }
  },

  computed: {
    socialNetworksList() {
      return socialNetworksList
    },
    isSharingEnabled() {
      return this.shareMode !== null
    },
    mediaUrlHD() {
      const videoUrl = this.video.media_original_url
      if (videoUrl) {
        if (videoUrl.includes('cdn.getpica.com')) {
          return `${videoUrl}/download`
        } else {
          return videoUrl
        }
      } else {
        return null
      }
    },
  },

  created() {
    this.SIZE_HD_VIDEO = SIZE_HD_VIDEO
    this.modalId = 'modal-video-player'
  },

  methods: {
    show(index) {
      Gallery.mediaOpened(this.video.id)
      this.$bvModal.show(this.modalId)
    },

    hide() {
      this.$bvModal.hide(this.modalId)
      // this.resetCurrentPhotoData()
      setTimeout(() => {
        this.displaySharing = false
        this.displayDownload = false
      }, 500)
    },

    async trackShare(network) {
      metric_message.createShareIntent(this.video.id, network.name)
    }
  }
}
</script>


